// Roles Store Module
import { createBaseModule } from './base'
import { rolesApi } from '@/services/api'

// Custom getters for roles
const customGetters = {
  // Get system roles (non-deletable)
  systemRoles: state => state.items.filter(role => role.is_system),

  // Get custom roles (can be deleted)
  customRoles: state => state.items.filter(role => !role.is_system),

  // Get role by name
  getRoleByName: state => name => 
    state.items.find(role => role.name?.toLowerCase() === name.toLowerCase()),

  // Get role display name
  getRoleName: state => roleId => {
    if (!roleId) return 'No Role'
    
    // Handle both role ID and role name cases
    let role = state.items.find(r => r.id === roleId || r.id === String(roleId))
    
    // If not found by ID, try by name (for string roles like 'admin', 'user', etc.)
    if (!role) {
      role = state.items.find(r => r.name?.toLowerCase() === String(roleId).toLowerCase())
    }
    
    // If still not found, check if it's a direct role string
    if (!role && typeof roleId === 'string') {
      const roleMap = {
        'user': 'User',
        'admin': 'Admin', 
        'moderator': 'Moderator',
        'superadmin': 'Super Admin',
        'super_admin': 'Super Admin'
      }
      return roleMap[roleId] || roleId.charAt(0).toUpperCase() + roleId.slice(1)
    }
    
    return role ? role.name : 'Unknown Role'
  }
}

// Create and export the roles module
export default createBaseModule('role', rolesApi, {
  customGetters
})
